import { recordingmodul_user_data_reducers } from "../reducers/recordingAuthReducers";

const modulRecording = {
  recordingmodul_user_data: recordingmodul_user_data_reducers,
};

export default modulRecording;
